export default "__VITE_ASSET__DLwhscKz__"